<template>
	<div></div>
</template>

<script>
export default {
	name: 'RouteListHeaders',
	setup() {},
}
</script>

<style lang="scss" scoped></style>
